module.exports = __webpack_public_path__ + "img/icdeposit.6bbe2052.png";